import Hero from './components/Hero';
import Identificacao from './components/Identificacao';
import QuebraCrenca from './components/QuebraCrenca';
import ProvaSocial from './components/ProvaSocial';
import NovoModelo from './components/NovoModelo';
import MetodoSimples from './components/MetodoSimples';
import Aprendizado from './components/Aprendizado';
import ApresentacaoMetodo from './components/ApresentacaoMetodo';
import ExemploEstrategia from './components/ExemploEstrategia';
import Ferramentas from './components/Ferramentas';
import Beneficios from './components/Beneficios';
import Oferta from './components/Oferta';
import Bonus from './components/Bonus';
import Autoridade from './components/Autoridade';
import Garantia from './components/Garantia';
import FAQ from './components/FAQ';
import CTAFinal from './components/CTAFinal';

export default function Home() {
  return (
    <div className="min-h-screen">
      {/* 🟢 TOPO */}
      <Hero />
      <Identificacao />
      <QuebraCrenca />

      {/* 🔥 MEIO - PROVA + CONVERSÃO */}
      <ProvaSocial />
      <NovoModelo />

      {/* 🧠 EXPLICAÇÃO + MÉTODO */}
      <MetodoSimples />
      <Aprendizado />
      <ApresentacaoMetodo />
      <ExemploEstrategia />

      {/* 💡 VALOR */}
      <Ferramentas />
      <Beneficios />

      {/* 💰 CONVERSÃO */}
      <Oferta />
      <Bonus />
      <Autoridade />
      <Garantia />
      <FAQ />

      {/* 🔥 FINAL */}
      <CTAFinal />
    </div>
  );
}